export const IFTTT_DARK_THEME = "ifttt-dark"

// Mirrors the on-dark tokens in `foundation/_colors.scss`; Monaco wants hex.
const PRIMARY = "ffffff"
const DISABLED = "585858"
const PROMO = "01b6ff"
const SUCCESS = "00c723"
const ALERT = "f45815"

// Everything the frame doesn't single out stays primary, so `inherit` is off:
// vs-dark would otherwise tint types, identifiers and delimiters on its own.
export function defineIftttDarkTheme(monaco) {
  monaco.editor.defineTheme(IFTTT_DARK_THEME, {
    base: "vs-dark",
    inherit: false,
    rules: [
      { token: "", foreground: PRIMARY },
      { token: "comment", foreground: DISABLED },
      { token: "keyword", foreground: PROMO },
      { token: "number", foreground: SUCCESS },
      { token: "string", foreground: ALERT },
    ],
  })
}
